export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-04.aea7ba50.jpg";